import Link from "next/link";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const BlogLatestPost = ({latestPost}) => {
    return (
        <>
            <div className={"latest-blog"}>
                <div className={"container"}>
                    <div className={"d-flex"}>
                        {latestPost.map((recentPost, index) => {
                            let latest = recentPost.node
                            let link = latest.slug;
                            if (latest?.parentSlug?.parentSlug != null && latest?.parentSlug?.parentSlug.length > 0) {
                                link = latest.parentSlug.parentSlug;
                            }
                            return <>
                                <div className={"post-item"}>
                                    <Link href={'/blog/category/' + latest.categories.nodes[0].slug + '/?page=1'}
                                          itemProp="url">
                                        <div
                                            className={`category ${latest.categories.nodes[0].slug}`}>{latest.categories.nodes[0].name}</div>
                                    </Link>
                                    <Link href={`/blog/${link}/`} itemProp="url">
                                        <h4>{latest.title}</h4>
                                    </Link>
                                    <div className={"date-time"}>{dayjs(latest?.modified).format("D MMM YYYY")}</div>
                                </div>
                            </>
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}
BlogLatestPost.defaultProps = {
    latestPost:[],
}
BlogLatestPost.propTypes = {
    latestPost:PropTypes.array.isRequired,
}
export default BlogLatestPost